import React from 'react';
import ConfirmDialog from '../../../common/ui/ConfirmDialog';

const DeleteConfirmModal = ({ visible, onCancel, onConfirm, signData, loading }) => (
  <ConfirmDialog
    open={visible}
    onCancel={onCancel}
    onConfirm={onConfirm}
    loading={loading}
    title="Conferma Eliminazione"
  >
    <div style={{ padding: '20px 0' }}>
      <p style={{ fontSize: '16px', marginBottom: '20px' }}>
        Sei sicuro di voler eliminare questo segnale?
      </p>
      {signData && (
        <div style={{ backgroundColor: '#f5f5f5', padding: '15px', borderRadius: '8px' }}>
          <div style={{ marginBottom: '10px' }}>
            <strong>Tipo:</strong> {signData.type?.replace('-', ' ')}
          </div>
          {signData.description && (
            <div style={{ marginBottom: '10px' }}>
              <strong>Descrizione:</strong> {signData.description}
            </div>
          )}
          <div>
            <strong>Coordinate:</strong> {signData.lat?.toFixed(6)}, {signData.lng?.toFixed(6)}
          </div>
        </div>
      )}
      <p style={{ color: '#ff4d4f', marginTop: '20px', fontWeight: 500 }}>
        Questa azione non può essere annullata.
      </p>
    </div>
  </ConfirmDialog>
);

export default DeleteConfirmModal;
